import type { TagsListProps } from '../../../components/AdCard/TagsList/TagsList.typed';
import { FreeHistoryReportTag } from '../../../components/Toolkit/Tags/PreBuilt/FreeHistoryReportTag';
import { GreenLightTag } from '../../../components/Toolkit/Tags/PreBuilt/GreenlightTag';
import { Tag } from '../../../components/Toolkit/Tags/Tag';
import * as Styled from '../../../components/AdCard/TagsList/TagsList.styled';
import { FEATURE_FREE_HISTORY_CHECK } from '../../../utils';

const TagsList = ({ tags, className }: TagsListProps) => (
  <Styled.Container className={className}>
    {tags?.map(({ displayName, type }) => {
      if (type === 'greenlight') {
        return <GreenLightTag key={displayName} />;
      }

      if (type === 'freeHistoryReport') {
        return FEATURE_FREE_HISTORY_CHECK ? (
          <FreeHistoryReportTag key={displayName} />
        ) : null;
      }
      return (
        <Tag key={displayName} text={displayName} textColor={'GREY_DARK'} />
      );
    })}
  </Styled.Container>
);

export { TagsList };
